import { useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { RequestWithAbort } from '@/server/requestWithAbort'
import { message } from 'antd'
import { useLoginModal } from '@/store/loginContext'
import { useUserStore } from '@/hooks/useUserStore'
import { sessionStore } from '@/utils/storage'
export function useAbortableRequest() {
  const requestRef = useRef<{ abort: () => void } | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<Error | null>(null)
  const { showLoginModal } = useLoginModal()
  const { dispatch } = useUserStore()
  const history = useHistory()
  const sendRequest = async (options: Parameters<typeof RequestWithAbort>[0], tip = { showTip: true }) => {
    setLoading(true)
    setError(null)
    try {
      const { res, abort }: any = await RequestWithAbort(options)
      requestRef.current = { abort }
      if (res?.code == 200 || res?.code == 1) {
        return { res }
      } else if (res?.code == 401 || res?.code == 402 || res?.code == 403 || res?.code == 405) {
        console.log('用户未登录，显示登录模态框')
        localStorage.clear()
        sessionStore.clear()
        dispatch({ type: 'CLEAR_USER_INFO' })
        showLoginModal()
        history.push('/')
        message.error(res?.msg)
      } else {
        if (tip?.showTip) message.error(res?.msg)
      }
    } catch (err: any) {
      if (err.name === 'AbortError') {
        console.warn('请求被手动取消')
        abort()
      } else {
        console.error('请求出错:', err)
        if (tip?.showTip) message.error(err)
        setError(err)
      }
    } finally {
      setLoading(false)
    }
  }

  const abort = () => {
    requestRef.current?.abort()
  }

  return { sendRequest, abort, loading, error }
}
